import { useDropzone } from "react-dropzone";
import { useCallback } from "react";
import './PhotosUploader.css'

export default function PhotosUploader({ onUpload }) {

  const onDrop = useCallback((acceptedFiles) => {
    onUpload(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className={`dropzone ${isDragActive ? "active" : ""}`}
    >
      <input {...getInputProps()} />
      <p>Glissez vos images ici ou cliquez</p>
    </div>
  );
}